/**
 * PageLoadingFallback - PR-PERF-2
 *
 * Professional loading state shown during route transitions
 * when lazy-loaded components are being fetched
 */

export default function PageLoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        {/* Professional Spinner */}
        <div className="relative w-16 h-16 mx-auto mb-4">
          {/* Background ring */}
          <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
          {/* Animated ring */}
          <div className="absolute inset-0 border-4 border-indigo-600 rounded-full border-t-transparent animate-spin"></div>
        </div>

        {/* Loading Text */}
        <p className="text-gray-600 font-medium text-lg">Loading...</p>

        {/* ExamLock Branding */}
        <p className="text-xs text-gray-400 mt-2">ExamLock</p>
      </div>
    </div>
  );
}
